import { ActionIcon, Button } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'

import { useColorSchemeStore } from '../MainLayout/stores/useColorSchemeStore'

const ButtonContent = ({
  openedSidebar,
  toggle,
  shouldDisable,
}: {
  openedSidebar: boolean
  toggle: () => void
  shouldDisable: boolean
}) => {
  const { getColors } = useColorSchemeStore()
  const colors = getColors()

  if (openedSidebar) {
    return (
      <Button
        leftSection={<IconPlus size={18} />}
        color={colors.alertBadge}
        fw={700}
        mb="md"
        w="100%"
        disabled={shouldDisable}
        onClick={toggle}
      >
        Add customer
      </Button>
    )
  }
  return (
    <ActionIcon
      variant="filled"
      color={colors.alertBadge}
      aria-label="Add customer"
      disabled={shouldDisable}
      onClick={toggle}
    >
      <IconPlus size={18} />
    </ActionIcon>
  )
}

export default ButtonContent
